/*!
 * @piconetworks/social-login-button v2.3.6
 * (c) 
 */
'use strict';

var React = require('react');
var qs = require('qs');
var PropTypes = require('prop-types');
var reactDom = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var qs__default = /*#__PURE__*/_interopDefaultLegacy(qs);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var generatePopup = function generatePopup(url, title) {
  var height = 540;
  var width = window.innerWidth > 540 ? 540 : window.innerWidth;
  var left = (window.screenLeft || window.screenX) + window.innerWidth / 2 - width / 2;
  var top = (window.screenTop || window.screenY) + window.innerHeight / 2 - height / 2;
  var options = Object.entries({
    alwaysOnTop: 1,
    alwaysRaised: 1,
    close: 0,
    copyhistory: 0,
    dependent: 1,
    dialog: 1,
    directories: 0,
    height: height,
    left: left,
    location: 0,
    menubar: 0,
    minimizable: 0,
    noopener: 0,
    personalbar: 0,
    resizable: 0,
    scrollbars: 0,
    status: 0,
    titlebar: 0,
    toolbar: 0,
    top: top,
    width: width
  }).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "".concat(key, "=").concat(value);
  }).join(',');
  var query = qs__default['default'].parse(query, {
    skipNulls: true
  });

  if (query.redirect_uri) {
    return window.top.location.replace(url);
  } else {
    return window.open(url, title, options);
  }
};

var PopupWindow = /*#__PURE__*/function (_Component) {
  _inherits(PopupWindow, _Component);

  var _super = _createSuper(PopupWindow);

  function PopupWindow(props) {
    var _this;

    _classCallCheck(this, PopupWindow);

    _this = _super.call(this, props); // STEP 1: create a container <div>

    _this.containerEl = document.createElement('div');
    _this.externalWindow = null;
    _this.timer = null;
    return _this;
  }

  _createClass(PopupWindow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          url = _this$props.url,
          title = _this$props.title,
          onClose = _this$props.onClose,
          handleResponse = _this$props.handleResponse;

      var closeFunction = onClose || function () {}; // STEP 3: open a new browser window and store a reference to it


      this.externalWindow = generatePopup(url, title);

      if (window.addEventListener) {
        window.addEventListener('message', handleResponse(this.externalWindow), false);
      } else if (window.attachEvent) {
        window.attachEvent('onmessage', handleResponse(this.externalWindow));
      } else {
        window.onload = handleResponse(this.externalWindow);
      } // STEP 4: append the container <div> (that has props.children appended to it) to the body of the new window


      window.document.body.appendChild(this.containerEl);
      this.timer = setInterval(function () {
        if (_this2.externalWindow.closed) {
          clearInterval(_this2.timer);
          closeFunction();
        }
      }, 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // STEP 5: This will fire when this.state.showWindowPortal in the parent component becomes false
      // So we tidy up by closing the window
      if (!this.externalWindow.closed) {
        this.externalWindow.close();
      }

      clearInterval(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      // STEP 2: append props.children to the container <div> that isn't mounted anywhere yet
      return /*#__PURE__*/reactDom.createPortal(this.props.children, this.containerEl);
    }
  }]);

  return PopupWindow;
}(React.Component);

var _window, _document;

var capitalize = function capitalize(s) {
  if (typeof s !== 'string') {
    return '';
  }

  return s.charAt(0).toUpperCase() + s.slice(1);
};

var SocialLoginButton = /*#__PURE__*/function (_Component) {
  _inherits(SocialLoginButton, _Component);

  var _super = _createSuper(SocialLoginButton);

  function SocialLoginButton(props) {
    var _this;

    _classCallCheck(this, SocialLoginButton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openPopup", function (e) {
      var previewMode = _this.props.previewMode;
      e.preventDefault();

      if (previewMode) {
        return;
      }

      _this.setState(function (state) {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          popup: true
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closePopup", function () {
      _this.setState(function (state) {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          popup: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loginResponse", function (authWindow) {
      return function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            source_origin = _ref.origin,
            data = _ref.data;

        var _this$props = _this.props,
            api_url = _this$props.api_url,
            onLogin = _this$props.onLogin,
            onFailure = _this$props.onFailure;
        var popup = _this.state.popup;

        if (source_origin === api_url && popup !== null) {
          var response;

          try {
            response = JSON.parse(data);
          } catch (error) {
            response = JSON.parse(JSON.stringify(data));
          }

          authWindow.close();

          if (response.error) {
            onFailure(response);
          } else {
            onLogin(response);
          }
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "isFacebookApp", function () {
      var ua = navigator.userAgent || navigator.vendor || window.opera;
      return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
    });

    _defineProperty(_assertThisInitialized(_this), "getPopupUrl", function () {
      var _this$props2 = _this.props,
          userId = _this$props2.userId,
          publisherId = _this$props2.publisherId,
          access_token = _this$props2.access_token,
          type = _this$props2.type,
          scope = _this$props2.scope,
          origin = _this$props2.origin,
          referer = _this$props2.referer,
          api_url = _this$props2.api_url,
          utm = _this$props2.utm,
          params = _this$props2.params,
          redirect_uri = _this$props2.redirect_uri;

      var query = _objectSpread2(_objectSpread2({}, params), {}, {
        redirect_uri: redirect_uri,
        utm: utm,
        origin: origin,
        client_id: "".concat(publisherId),
        jwt: access_token,
        user_id: userId,
        referer: referer
      });

      if (_this.isFacebookApp() && !redirect_uri) {
        query.redirect_uri = window.location.ancestorOrigins[0];
      }

      return "".concat(api_url, "/connect/").concat(type, "/").concat(scope, "?").concat(qs__default['default'].stringify(query, {
        skipNulls: true
      }));
    });

    if (!props.api_url) {
      throw new Error('Invalid api_url');
    }

    _this.state = {
      popup: null,
      response: null
    };
    return _this;
  }

  _createClass(SocialLoginButton, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          type = _this$props3.type,
          content = _this$props3.content,
          button = _this$props3.button,
          previewMode = _this$props3.previewMode;
      var popup = this.state.popup;
      var button_component;

      if (button) {
        button_component = /*#__PURE__*/React__default['default'].cloneElement(button, {
          onClick: this.openPopup
        });
      } else {
        button_component = /*#__PURE__*/React__default['default'].createElement("button", {
          onClick: this.openPopup
        }, content || children);
      }

      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, popup && !previewMode && /*#__PURE__*/React__default['default'].createElement(PopupWindow, {
        url: this.getPopupUrl(),
        title: "".concat(capitalize(type), " Login"),
        handleResponse: this.loginResponse,
        onClose: this.closePopup
      }), button_component);
    }
  }]);

  return SocialLoginButton;
}(React.Component);

_defineProperty(SocialLoginButton, "propTypes", {
  access_token: PropTypes__default['default'].string,
  api_url: PropTypes__default['default'].string.isRequired,
  button: PropTypes__default['default'].any,
  children: PropTypes__default['default'].node,

  /** We're trying to deprecate things like content in lieu of children */
  content: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  onLogin: PropTypes__default['default'].func,
  params: PropTypes__default['default'].shape({
    article_id: PropTypes__default['default'].string,
    form_id: PropTypes__default['default'].string,
    newsletter_ids: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    custom_fields: PropTypes__default['default'].object
  }),
  previewMode: PropTypes__default['default'].bool,
  publisherId: PropTypes__default['default'].string,
  referer: PropTypes__default['default'].string,
  origin: PropTypes__default['default'].string,
  scope: PropTypes__default['default'].string,
  type: PropTypes__default['default'].string.isRequired,
  userId: PropTypes__default['default'].string,
  redirect_uri: PropTypes__default['default'].string,
  utm: PropTypes__default['default'].shape({
    campaign: PropTypes__default['default'].string,
    source: PropTypes__default['default'].string,
    medium: PropTypes__default['default'].string,
    content: PropTypes__default['default'].string,
    term: PropTypes__default['default'].string
  })
});

_defineProperty(SocialLoginButton, "defaultProps", {
  onFailure: console.error,
  onLogin: console.log,
  previewMode: false,
  disabled: false,
  origin: typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window.location.origin),
  referer: typeof document !== 'undefined' && ((_document = document) === null || _document === void 0 ? void 0 : _document.referrer),
  redirect_uri: null,
  access_token: null,
  scope: 'user',
  params: {},
  utm: {
    campaign: null,
    source: null,
    medium: null,
    content: null,
    term: null
  }
});

module.exports = SocialLoginButton;
